import { FC, Fragment } from "react";
import { BillingExplorerExplainWithAiAnomalyTrendItem } from "@/components/pages/resource-explorer/components/explain-with-ai-panel/components/body/anomalies/BillingExplorerExplainWithAiAnomalyTrendItem";
import { BillingExplorerExplainWithAiAnomaliesSpike } from "@/components/pages/resource-explorer/components/explain-with-ai-panel/components/body/anomalies/BillingExplorerExplainWithAiAnomaliesSpike";
import { ExplorerSummaryAnomaliesFormattedDataType } from "@/store/resource-explorer/selectors/resource-explorer-summary/billingExplorerSummaryAnomaliesFormattedDataSelector";
import { ExplainWithAiAnomaliesTypes } from "@/components/pages/resource-explorer/components/explain-with-ai-panel/components/utils/types";

interface ExplainWithAiAnomaliesTrendsProps {
  tab: ExplainWithAiAnomaliesTypes | null;
  data?: ExplorerSummaryAnomaliesFormattedDataType;
}

export const ExplainWithAiAnomaliesTrends: FC<
  ExplainWithAiAnomaliesTrendsProps
> = ({ tab, data }) => {
  return (
    <Fragment>
      {tab === "increaseTrends" &&
        data?.increaseTrends?.map((item, index) => {
          return (
            <BillingExplorerExplainWithAiAnomalyTrendItem
              key={item.id}
              type="increase"
              {...item}
            />
          );
        })}
      {tab === "decreaseTrends" &&
        data?.decreaseTrends?.map((item, index) => {
          return (
            <BillingExplorerExplainWithAiAnomalyTrendItem
              key={item.id}
              type="decrease"
              {...item}
            />
          );
        })}
      {tab === "spikes" &&
        data?.spikes?.map((item, index) => {
          return (
            <BillingExplorerExplainWithAiAnomaliesSpike
              key={item.id}
              {...item}
            />
          );
        })}
    </Fragment>
  );
};
